export const idbGeneralFormStore = (adaptive: boolean) => `quest${adaptive ? '.adaptive' : ''}.generalForm`;
export const idbOptionsFormStore = (adaptive: boolean) => `quest${adaptive ? '.adaptive' : ''}.optionsForm`;
export const idbStepsFormStore = (adaptive: boolean) => `quest${adaptive ? '.adaptive' : ''}.stepsForm`;
